import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SalesrefService } from "./salesref.service";


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private salesRefService: SalesrefService, private router: Router) {}

  // the Router call canActivate() method,
  // if canActivate is registered in Routes[]
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const isValid = this.salesRefService.refinfo.isValid;
        if (!isValid) {
          this.router.navigateByUrl("/");
          return resolve(false);
        } else {
          return resolve(true);
        }
      });
    }
  }
